import { Component } from '@angular/core';
import { RouterLink } from '@angular/router';
import { NewsletterComponent } from '../../shared/components/newsletter/newsletter.component';
import { FeaturesComponent } from '../../shared/components/features/features.component';

@Component({
  selector: 'app-contact',
  standalone: true,
  imports: [RouterLink, NewsletterComponent, FeaturesComponent],
  templateUrl: './contact.component.html',
  styleUrl: './contact.component.css'
})
export class ContactComponent {

}
